// extracted by mini-css-extract-plugin
export default {"container":"AcademicAffairsFilter_container__f-QBf","actionWrap":"AcademicAffairsFilter_actionWrap__cgJ0H"};